export function stripRouteIdsFromUrl(url: string) {
	// Parse the original URL
	const parsedUrl = new URL(url);

	// Split the pathname into segments
	let pathSegments = parsedUrl.pathname.split("/");

	// Filter out segments enclosed in parentheses
	pathSegments = pathSegments.filter(
		(segment) => !(segment.startsWith("(") && segment.endsWith(")"))
	);

	// Check if the path starts with 'tutorials' or 'guides'
	if (pathSegments[1] === "tutorials" || pathSegments[1] === "guides") {
		return url; // Return the original URL without modifications
	}

	// Reconstruct the pathname
	const simplifiedPathname = pathSegments.join("/");

	// Construct the new URL
	const simplifiedUrl = `${parsedUrl.protocol}//${parsedUrl.host}${simplifiedPathname}`;

	return simplifiedUrl;
}
